import { zodResolver } from '@hookform/resolvers/zod'
import { transformData } from 'global/guides/Dialog/DialogGuideRoot'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'sonner'
import { ZodEffects, ZodObject } from 'zod'

interface IProps {
    schema: ZodObject<any> | ZodEffects<any>
    defaultValues?: any
    disableFields?: boolean
    children: React.ReactNode
    reValidateMode?: 'onBlur' | 'onChange' | 'onSubmit'
}

export default function ZodFormProvider({
    schema,
    defaultValues,
    disableFields,
    reValidateMode = 'onSubmit',
    children,
}: IProps) {
    const methods = useForm({
        defaultValues: transformData(defaultValues),
        resolver: async (data, context, options) =>
            zodResolver(schema)(data, context, options)
                .then(result => {
                    const errors = Object.keys(result.errors)

                    if (errors.length > 0) {
                        toast.error(
                            'Verifique os campos com erros: ' +
                                errors.join(','),
                        )
                    }

                    return result
                })
                .catch(err => {
                    console.error('err', err)
                    toast.error('Há campos obrigatórios não preenchidos!')
                    return err
                }),
        reValidateMode,
    })

    methods.control._options = {
        ...methods.control._options,
        disabled: disableFields,
    }

    return <FormProvider {...methods}>{children}</FormProvider>
}
